// Digest: 81c0ba4abef5e1512d97bde6fd57508f8a267107
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ContainerSizeSubBlockOrNull = null | ContainerSizeSubBlock;
export type AlignedRichTextSubBlockOrNull = null | AlignedRichTextSubBlock;
export type RichTextBlockOrNull = null | RichTextBlock;
export type RichTextBlock = string;
export type _SlideListOrNull = null | _SlideList;
export type ImageChooserBlockOrNull = null | ImageChooserBlock;
export type _SlideList = _Slide[];
export type CharBlockOrNull = null | CharBlock;
export type CharBlock = string;
export type EmbedBlockOrNull = null | EmbedBlock;
export type EmbedBlock = string;
export type MediaChooserBlock = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "video";
      value: VideoChooserBlock;
      id: string;
    }
  | {
      type: "embed";
      value: MediaEmbedBlock;
      id: string;
    }
)[];
export type URLBlockOrNull = null | URLBlock;
export type URLBlock = string;
export type TableBlockOrNull = null | TableBlock;
export type TableBlock = string;
export type LabUIToolbox = (
  | {
      type: "alignedrichtextblock";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "gallerysubblock";
      value: GallerySubBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: LinkSubBlock;
      id: string;
    }
  | {
      type: "mediachooserblock";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "scrollnavmenublock";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scrollnavmenuitemblock";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "socialmediaicon";
      value: SocialMediaIcon;
      id: string;
    }
  | {
      type: "spacerblock";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "tableincontainerblock";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "videochooserblock";
      value: VideoChooserBlock;
      id: string;
    }
)[];
export type AccordionItemsListOrNull = null | AccordionItemsList;
export type AccordionItemsList = AccordionItems[];
export type CarouselItemBlockListOrNull = null | CarouselItemBlockList;
export type MediaChooserBlockOrNull = null | MediaChooserBlock;
export type CarouselItemBlockList = CarouselItemBlock[];
export type CmsContactOrNull = null | Cms;
export type NewsContactInfoBody = {
  type: "contact";
  value: NewsContactInfoBlock;
  id: string;
}[];
export type ColorOptionsSubBlockOrNull = null | ColorOptionsSubBlock;
export type ColorOptionsSubBlock = "" | "darkMode" | "lightMode";
export type CmsRichTextSnippetOrNull = null | Cms2;
export type ScrollAnimationSubBlockOrNull = null | ScrollAnimationSubBlock;
export type ScrollAnimationSubBlock = "" | "none" | "left" | "up" | "reveal-from-left";
export type RichTextBody = {
  type: "rich_text";
  value: RichTextWithOptionsBlock;
  id: string;
}[];
export type ContainerReadyToolbox = (
  | {
      type: "accordion";
      value: AccordionBlock;
      id: string;
    }
  | {
      type: "carousel";
      value: CarouselBlock;
      id: string;
    }
  | {
      type: "contacts";
      value: ContactsBlock;
      id: string;
    }
  | {
      type: "media";
      value: MediaBlock;
      id: string;
    }
  | {
      type: "rich_text_snippet";
      value: RichTextSnippetBlock;
      id: string;
    }
  | {
      type: "rich_text_with_options";
      value: RichTextWithOptionsBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SupernalSpacerBlock;
      id: string;
    }
)[];
export type ContainerReadyToolboxOrNull = null | ContainerReadyToolbox;
export type ColumnGridListListOrNull = null | ColumnGridListList;
export type SupernalLinkSubBlockOrNull = null | SupernalLinkSubBlock;
export type ColumnGridListList = ColumnGridList[];
export type EcosystemRichTextBlockOrNull = null | EcosystemRichTextBlock;
export type VideoChooserBlockOrNull = null | VideoChooserBlock;
export type EcosystemPointOfInterestBlockListOrNull = null | EcosystemPointOfInterestBlockList;
export type FloatBlockOrNull = null | FloatBlock;
export type FloatBlock = number;
export type EcosystemPointOfInterestBlockList = EcosystemPointOfInterestBlock[];
export type HorizontalScrollSlideListOrNull = null | HorizontalScrollSlideList;
export type BooleanBlockOrNull = null | BooleanBlock;
export type BooleanBlock = boolean;
export type HorizontalScrollSlideMediaListOrNull = null | HorizontalScrollSlideMediaList;
export type HorizontalScrollSlideMediaList = HorizontalScrollSlideMedia[];
export type HorizontalScrollSlideList = HorizontalScrollSlide[];
export type NewsTickerSubBlockListOrNull = null | NewsTickerSubBlockList;
export type NewsTickerSubBlockList = NewsTickerSubBlock[];
export type PrincipleDetailsSubBlockListOrNull = null | PrincipleDetailsSubBlockList;
export type PrincipleDetailsSubBlockList = PrincipleDetailsSubBlock[];
export type PrinciplesSubBlockListOrNull = null | PrinciplesSubBlockList;
export type PrinciplesSubBlockList = PrinciplesSubBlock[];
export type StaggeredImageTextSubBlockListOrNull = null | StaggeredImageTextSubBlockList;
export type StaggeredImageTextSubBlockList = StaggeredImageTextSubBlock[];
export type TabbedSubBlockListOrNull = null | TabbedSubBlockList;
export type TabbedSubBlockList = TabbedSubBlock[];
export type TimelineSubBlockListOrNull = null | TimelineSubBlockList;
export type DateBlockOrNull = null | DateBlock;
export type DateBlock = string;
export type TimelineSubBlockList = TimelineSubBlock[];
export type CmsValuePropListOrNull = null | Cms3;
export type Cms3 = Cms4[];
export type Toolbox = (
  | {
      type: "accordion";
      value: AccordionBlock;
      id: string;
    }
  | {
      type: "aligned_container";
      value: AlignedContainerBlock;
      id: string;
    }
  | {
      type: "aligned_hero";
      value: AlignedHeroBlock;
      id: string;
    }
  | {
      type: "carousel";
      value: CarouselBlock;
      id: string;
    }
  | {
      type: "column_grid";
      value: ColumnGridBlock;
      id: string;
    }
  | {
      type: "ecosystem";
      value: EcosystemBlock;
      id: string;
    }
  | {
      type: "email_signup";
      value: EmailSignupBlock;
      id: string;
    }
  | {
      type: "email_signup_hero";
      value: EmailSignupHeroBlock;
      id: string;
    }
  | {
      type: "events";
      value: EventsBlock;
      id: string;
    }
  | {
      type: "featured_rich_text";
      value: FeaturedRichTextBlock;
      id: string;
    }
  | {
      type: "hero";
      value: HeroBlock;
      id: string;
    }
  | {
      type: "homepage_hero";
      value: HomepageHeroBlock;
      id: string;
    }
  | {
      type: "horizontal_scroll";
      value: HorizontalScrollBlock;
      id: string;
    }
  | {
      type: "image_chooser";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: SupernalLinkSubBlock;
      id: string;
    }
  | {
      type: "media";
      value: MediaBlock;
      id: string;
    }
  | {
      type: "media_promo";
      value: MediaPromoBlock;
      id: string;
    }
  | {
      type: "news_curated_articles";
      value: NewsCuratedArticlesBlock;
      id: string;
    }
  | {
      type: "news_featured_articles";
      value: NewsFeaturedArticlesBlock;
      id: string;
    }
  | {
      type: "news_hero";
      value: NewsHeroBlock;
      id: string;
    }
  | {
      type: "news_ticker";
      value: NewsTickerBlock;
      id: string;
    }
  | {
      type: "principle_details";
      value: PrincipleDetailsBlock;
      id: string;
    }
  | {
      type: "principles";
      value: PrinciplesBlock;
      id: string;
    }
  | {
      type: "scroll_nav_menu";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scroll_nav_menu_item";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SupernalSpacerBlock;
      id: string;
    }
  | {
      type: "staggered_image_text";
      value: StaggeredImageTextBlock;
      id: string;
    }
  | {
      type: "tabbed";
      value: TabbedBlock;
      id: string;
    }
  | {
      type: "timeline";
      value: TimelineBlock;
      id: string;
    }
  | {
      type: "team_members";
      value: TeamMembersBlock;
      id: string;
    }
  | {
      type: "value_props";
      value: ValuePropsBlock;
      id: string;
    }
  | {
      type: "vehicle_landing";
      value: VehicleLandingBlock;
      id: string;
    }
)[];
export type DocumentChooserBlockOrNull = null | DocumentChooserBlock;
export type CmsNewsContactInfoOrNull = null | Cms1;
export type PageChooserBlockOrNull = null | PageChooserBlock;
export type NewsroomToolbox = (
  | {
      type: "email_signup";
      value: EmailSignupBlock;
      id: string;
    }
  | {
      type: "events";
      value: EventsBlock;
      id: string;
    }
  | {
      type: "featured_rich_text";
      value: FeaturedRichTextBlock;
      id: string;
    }
  | {
      type: "media_inquiry";
      value: MediaInquiryBlock;
      id: string;
    }
  | {
      type: "news_hero";
      value: NewsHeroBlock;
      id: string;
    }
  | {
      type: "news_article_grid";
      value: NewsArticleGridBlock;
      id: string;
    }
  | {
      type: "scroll_nav_menu";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scroll_nav_menu_item";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SupernalSpacerBlock;
      id: string;
    }
)[];
export type SimpleLinkBlockOrNull = null | SimpleLinkBlock;
export type MenuItemBlockList = MenuItemBlock[];
export type SimpleLinkBlockList = SimpleLinkBlock[];
export type SupernalLinkSubBlockListOrNull = null | SupernalLinkSubBlockList;
export type SupernalLinkSubBlockList = SupernalLinkSubBlock[];
export type SocialMediaIconList = SocialMediaIcon[];
export type HeaderNavigationBodyBlock = (
  | {
      type: "menu_items";
      value: MenuItemBlockList;
      id: string;
    }
  | {
      type: "links";
      value: SimpleLinkBlockList;
      id: string;
    }
  | {
      type: "legal";
      value: LegalBlock;
      id: string;
    }
  | {
      type: "icons";
      value: SocialMediaIconList;
      id: string;
    }
)[];
export type FooterNavigationBodyBlock = (
  | {
      type: "links";
      value: SupernalLinkSubBlockList;
      id: string;
    }
  | {
      type: "legal";
      value: LegalBlock;
      id: string;
    }
  | {
      type: "icons";
      value: SocialMediaIconList;
      id: string;
    }
)[];
export type SocialMediaShareBlock = {
  type: "items";
  value: SocialMediaShareSite;
  id: string;
}[];

export interface _Types {
  BasePageTemplateProps: ThelabuiModelsPagesBasePageBasePageTemplate;
  BaseFormPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate;
  BaseFormPageLandingPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate;
  ExamplePageTemplateProps: ThelabuiModelsPagesExamplePageExamplePageTemplate;
  LabUIToolboxSnippetPreviewProps: ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview;
  NewsArticlePageTemplateProps: ServerCmsModelsPagesNewsArticlePageNewsArticlePageTemplate;
  TeamMemberPageTemplateProps: ServerCmsModelsPagesTeamMemberPageTeamMemberPageTemplate;
  ContactUsPageTemplateProps: ServerCmsModelsPagesContactUsPageContactUsPageTemplate;
  ContactUsLandingPageTemplateProps: ServerCmsModelsPagesContactUsPageContactUsLandingPageTemplate;
  HomePageTemplateProps: ServerCmsModelsPagesHomePageHomePageTemplate;
  NewsCoverageLandingPageTemplateProps: ServerCmsModelsPagesNewsCoverageLandingPageNewsCoverageLandingPageTemplate;
  TeamMembersLandingPageTemplateProps: ServerCmsModelsPagesTeamMembersLandingPageTeamMembersLandingPageTemplate;
  UtilityPageTemplateProps: ServerCmsModelsPagesUtilityPageUtilityPageTemplate;
  globals: {
    Widget:
      | DjangoFormsWidgetsSelect
      | DjangoFormsWidgetsTextInput
      | DjangoFormsWidgetsEmailInput
      | DjangoFormsWidgetsTextarea
      | DjangoFormsWidgetsCheckboxInput;
    models: {};
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ServerCmsContextProcessorsCoreAssetProcessor &
    ServerCmsContextProcessorsSettingsProcessor &
    ServerCmsContextProcessorsNavigationProcessor &
    ServerCmsContextProcessorsSocialMediaShareProcessor;
  RPCPermission: null;
}
export interface ThelabuiModelsPagesBasePageBasePageTemplate {
  is_preview: boolean;
  page: BasePageD82Bdbd051;
}
export interface BasePageD82Bdbd051 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate {
  is_preview: boolean;
  page: BaseFormPageC06E1539E6;
  form: DjangoFormsForms;
}
export interface BaseFormPageC06E1539E6 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
}
export interface DjangoFormsForms {
  name: "django.forms.forms.Form";
  errors: {} | null;
  fields: {};
  prefix: string;
  iterator: [];
  hidden_fields?: [];
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate {
  is_preview: boolean;
  page: BaseFormPageC06E1539E6;
}
export interface ThelabuiModelsPagesExamplePageExamplePageTemplate {
  is_preview: boolean;
  page: ExamplePage_598A50Eb5C;
}
export interface ExamplePage_598A50Eb5C {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  image: {
    block: ThelabuiSerializationImagesImageBlockValue;
  } | null;
  image_tile: {
    renditions_webp: WagtailImageRendition[];
  } | null;
  richtext: RichTextField;
  body: ThelabuiExamplePage;
  snippets: {
    body: ThelabuiLabUIToolboxSnippet;
  }[];
  attachment: {
    title: string;
    created_at: string;
    file_size: number | null;
    file_hash: string;
    filename: string;
    file_extension: string;
    url: string;
    content_type: string;
    content_disposition: string;
    file: FileField;
    tags: {
      name: string;
    }[];
  } | null;
}
export interface ThelabuiSerializationImagesImageBlockValue {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface ThelabuiSerializationImagesImageRenditionBlockValue {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface WagtailImageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface RichTextField {
  _type: "RichTextField";
  html: string;
}
export interface ThelabuiExamplePage {
  _type: "StreamField";
  _variant: "thelabui.ExamplePage.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface AlignedRichTextBlock {
  container?: ContainerSizeSubBlockOrNull;
  content?: AlignedRichTextSubBlockOrNull;
}
export interface ContainerSizeSubBlock {
  width?: null | ("" | "full" | "twoThirds" | "half");
}
export interface AlignedRichTextSubBlock {
  content?: RichTextBlockOrNull;
  alignment?: null | ("" | "textAlignCenter" | "textAlignRight");
}
export interface GallerySubBlock {
  slides?: _SlideListOrNull;
}
export interface _Slide {
  image: ImageChooserBlockOrNull;
  caption?: AlignedRichTextSubBlockOrNull;
}
export interface ImageChooserBlock {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^.*$".
     */
    [k: string]: {
      spec: string;
      width: number;
      height: number;
      url: string;
      size: number;
      mimetype: string;
    };
  };
}
export interface LinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "secondary" | "text-link");
  url: null | string;
}
export interface VideoChooserBlock {
  poster: null | string;
  sources: {
    url: string;
    mimetype: string;
  }[];
  title: string;
  tracks: {
    kind: string;
    src: string;
    label: string;
    srclang: string;
    sort_order: number;
  }[];
}
export interface MediaEmbedBlock {
  title: CharBlockOrNull;
  thumbnail: ImageChooserBlockOrNull;
  embed: EmbedBlockOrNull;
}
export interface ScrollNavMenuBlock {}
export interface ScrollNavMenuItemBlock {
  name: CharBlockOrNull;
}
export interface SocialMediaIcon {
  icon: null | ("facebook" | "twitter" | "youtube" | "linkedin" | "instagram" | "tiktok");
  link: URLBlockOrNull;
}
export interface SpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
}
export interface TableInContainerBlock {
  container?: ContainerSizeSubBlockOrNull;
  table: TableBlockOrNull;
}
export interface ThelabuiLabUIToolboxSnippet {
  _type: "StreamField";
  _variant: "thelabui.LabUIToolboxSnippet.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface FileField {
  url: string;
}
export interface ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview {
  object: LabUIToolboxSnippetFdc2906E1B;
}
export interface LabUIToolboxSnippetFdc2906E1B {
  id: number;
  name: string;
  body: ThelabuiLabUIToolboxSnippet;
}
export interface ServerCmsModelsPagesNewsArticlePageNewsArticlePageTemplate {
  is_preview: boolean;
  page: NewsArticlePage_0659E39E2D;
}
export interface NewsArticlePage_0659E39E2D {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  article_title: string;
  article_date_formatted: string;
  article_asset_url: string | null;
  article_asset_cta_text: string | null;
  article_tags: {
    name: string;
  }[];
  article_writer_object: ServerCmsModelsPagesNewsArticlePageArticleWriter | null;
  body: CmsNewsArticlePage;
  contact_group: {
    body: CmsNewsContactInfo;
  } | null;
  image: {
    block: ThelabuiSerializationImagesImageBlockValue1;
  } | null;
  event_daterange: DateTimeRangeField | null;
  event_daterange_formatted: string | null;
  event_location: string | null;
  event_logo: {
    block: ThelabuiSerializationImagesImageBlockValue2;
  } | null;
  event_booth: string | null;
  event_url: string | null;
  event_url_text: string | null;
  parent_page_link: ServerCmsModelsPagesNewsArticlePageParentPageLink;
}
export interface ServerCmsModelsPagesNewsArticlePageArticleWriter {
  name: string;
  email: string;
  avatar: ServerCmsModelsPagesNewsArticlePageImage;
}
export interface ServerCmsModelsPagesNewsArticlePageImage {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ServerCmsModelsPagesNewsArticlePageRendition;
  };
}
export interface ServerCmsModelsPagesNewsArticlePageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface CmsNewsArticlePage {
  _type: "StreamField";
  _variant: "cms.NewsArticlePage.body";
  value: ContainerReadyToolbox;
  [k: string]: unknown;
}
export interface AccordionBlock {
  header?: RichTextBlockOrNull;
  items?: AccordionItemsListOrNull;
}
export interface AccordionItems {
  eyebrow?: RichTextBlockOrNull;
  header: RichTextBlockOrNull;
  body?: RichTextBlockOrNull;
}
export interface CarouselBlock {
  media?: CarouselItemBlockListOrNull;
}
export interface CarouselItemBlock {
  media: MediaChooserBlockOrNull;
  caption?: CharBlockOrNull;
}
export interface ContactsBlock {
  header: RichTextBlockOrNull;
  body:
    | null
    | (
        | {
            type: "contact";
            value: Cms;
            id: string;
          }
        | {
            type: "contact_group";
            value: Cms1;
            id: string;
          }
      )[];
}
export interface Cms {
  avatar?: ImageChooserBlockOrNull;
  name: CharBlock;
  email?: CharBlock;
  company?: CharBlock;
}
export interface Cms1 {
  body: NewsContactInfoBody;
}
export interface NewsContactInfoBlock {
  role: CharBlockOrNull;
  contact: CmsContactOrNull;
}
export interface MediaBlock {
  color_options?: ColorOptionsSubBlockOrNull;
  media?: MediaChooserBlockOrNull;
}
export interface RichTextSnippetBlock {
  rich_text: CmsRichTextSnippetOrNull;
}
export interface Cms2 {
  body: RichTextBody;
}
export interface RichTextWithOptionsBlock {
  animation_options?: ScrollAnimationSubBlockOrNull;
  body: RichTextBlockOrNull;
}
export interface SupernalSpacerBlock {
  background_color: null | ("transparent" | "white" | "black");
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "xsmall" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
}
export interface CmsNewsContactInfo {
  _type: "StreamField";
  _variant: "cms.NewsContactInfo.body";
  value: NewsContactInfoBody;
  [k: string]: unknown;
}
export interface ThelabuiSerializationImagesImageBlockValue1 {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface DateTimeRangeField {
  lower: string | null;
  upper: string | null;
}
export interface ThelabuiSerializationImagesImageBlockValue2 {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface ServerCmsModelsPagesNewsArticlePageParentPageLink {
  title: string;
  url: string;
}
export interface ServerCmsModelsPagesTeamMemberPageTeamMemberPageTemplate {
  is_preview: boolean;
  page: TeamMemberPage_8D6Df08513;
}
export interface TeamMemberPage_8D6Df08513 {
  id: number;
  title: string;
  headshot: {
    block: ThelabuiSerializationImagesImageBlockValue3;
  } | null;
  job_title: string;
  bio: RichTextField;
}
export interface ThelabuiSerializationImagesImageBlockValue3 {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface ServerCmsModelsPagesContactUsPageContactUsPageTemplate {
  is_preview: boolean;
  page: ContactUsPageE5Ecca2Dbf;
  form: ServerCmsForms;
}
export interface ContactUsPageE5Ecca2Dbf {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsContactUsPage;
}
export interface CmsContactUsPage {
  _type: "StreamField";
  _variant: "cms.ContactUsPage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface AlignedContainerBlock {
  color_options?: ColorOptionsSubBlockOrNull;
  alignment: null | ("left" | "right" | "center");
  width: null | "twoThirds";
  items: ContainerReadyToolboxOrNull;
}
export interface AlignedHeroBlock {
  mobile_background_color?: ColorOptionsSubBlockOrNull;
  alignment: null | ("left" | "right");
  heading: RichTextBlockOrNull;
  body?: RichTextBlockOrNull;
  media?: MediaChooserBlockOrNull;
}
export interface ColumnGridBlock {
  color_options?: ColorOptionsSubBlockOrNull;
  grid?: ColumnGridListListOrNull;
}
export interface ColumnGridList {
  image: ImageChooserBlockOrNull;
  sub_body: RichTextBlockOrNull;
  cta?: SupernalLinkSubBlockOrNull;
}
export interface SupernalLinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "stroke" | "borderless" | "text-link");
  query_params?: CharBlockOrNull;
  url: null | string;
}
export interface EcosystemBlock {
  intro_text?: EcosystemRichTextBlockOrNull;
  background_intro_video: VideoChooserBlockOrNull;
  background_video: VideoChooserBlockOrNull;
  background_video_mobile?: VideoChooserBlockOrNull;
  timeline?: EcosystemPointOfInterestBlockListOrNull;
}
export interface EcosystemRichTextBlock {
  text: RichTextBlockOrNull;
  cta_text: CharBlockOrNull;
}
export interface EcosystemPointOfInterestBlock {
  name: CharBlockOrNull;
  text?: EcosystemRichTextBlockOrNull;
  video_timestamp: FloatBlockOrNull;
}
export interface EmailSignupBlock {}
export interface EmailSignupHeroBlock {
  alignment?: null | ("" | "rightSideText");
  media?: MediaChooserBlockOrNull;
  header: CharBlockOrNull;
  copy: RichTextBlockOrNull;
  link?: CharBlockOrNull;
}
export interface EventsBlock {
  events: {
    headline?: string;
    location?: string | null;
    page_url?: string;
    event_daterange?: string | null;
    [k: string]: unknown;
  }[];
}
export interface FeaturedRichTextBlock {
  color_options?: ColorOptionsSubBlockOrNull;
  animation_options?: ScrollAnimationSubBlockOrNull;
  body: RichTextBlockOrNull;
  cta?: SupernalLinkSubBlockOrNull;
}
export interface HeroBlock {
  media?: MediaChooserBlockOrNull;
  header: RichTextBlockOrNull;
  copy?: RichTextBlockOrNull;
  long_video?: MediaChooserBlockOrNull;
  long_video_thumbnail?: ImageChooserBlockOrNull;
}
export interface HomepageHeroBlock {
  background_media: MediaChooserBlockOrNull;
  headline: RichTextBlockOrNull;
  video?: VideoChooserBlockOrNull;
  video_cta?: CharBlockOrNull;
  body: RichTextBlockOrNull;
  cta?: SupernalLinkSubBlockOrNull;
}
export interface HorizontalScrollBlock {
  color_options?: ColorOptionsSubBlockOrNull;
  header?: RichTextBlockOrNull;
  carousel?: HorizontalScrollSlideListOrNull;
}
export interface HorizontalScrollSlide {
  show_chevron?: BooleanBlockOrNull;
  sub_body: RichTextBlockOrNull;
  cta?: SupernalLinkSubBlockOrNull;
  media_cta?: CharBlockOrNull;
  media?: HorizontalScrollSlideMediaListOrNull;
}
export interface HorizontalScrollSlideMedia {
  media: MediaChooserBlockOrNull;
  caption?: CharBlockOrNull;
}
export interface MediaPromoBlock {
  body: RichTextBlockOrNull;
  link?: SupernalLinkSubBlockOrNull;
  media: MediaChooserBlockOrNull;
}
export interface NewsCuratedArticlesBlock {
  header: CharBlockOrNull;
  page: PageChooserBlock;
  articles: (
    | {
        id: number;
        article_title: string;
        article_date: string;
        article_type?: string;
        article_tags?: string[] | null;
        article_url: string;
        image: ImageChooserBlockOrNull;
      }
    | {
        id: number;
        article_title: string;
        article_date: string;
        article_type?: string;
        article_tags?: string[] | null;
        article_url: string;
        image: ImageChooserBlockOrNull;
        event_daterange?: {
          lower?: string | null;
          upper?: string | null;
          [k: string]: unknown;
        };
        event_location?: string | null;
        event_booth?: string | null;
        event_url_text?: string | null;
        event_url?: string | null;
        event_logo?: ImageChooserBlockOrNull;
      }
  )[];
}
export interface PageChooserBlock {
  id: number;
  url: string;
  title: string;
}
export interface NewsFeaturedArticlesBlock {
  header?: CharBlockOrNull;
  page?: PageChooserBlock;
  articles: (
    | {
        id: number;
        article_title: string;
        article_date: string;
        article_type?: string;
        article_tags?: string[] | null;
        article_url: string;
        image: ImageChooserBlockOrNull;
      }
    | {
        id: number;
        article_title: string;
        article_date: string;
        article_type?: string;
        article_tags?: string[] | null;
        article_url: string;
        image: ImageChooserBlockOrNull;
        event_daterange?: {
          lower?: string | null;
          upper?: string | null;
          [k: string]: unknown;
        };
        event_location?: string | null;
        event_booth?: string | null;
        event_url_text?: string | null;
        event_url?: string | null;
        event_logo?: ImageChooserBlockOrNull;
      }
  )[];
}
export interface NewsHeroBlock {
  headline: CharBlock;
  copy?: CharBlockOrNull;
  page_url: CharBlock;
  tags?: string[] | null;
  event_daterange?: CharBlockOrNull;
  event_location?: CharBlockOrNull;
  image: ImageChooserBlockOrNull;
}
export interface NewsTickerBlock {
  ticker_items?: NewsTickerSubBlockListOrNull;
}
export interface NewsTickerSubBlock {
  text: CharBlockOrNull;
}
export interface PrincipleDetailsBlock {
  columns?: PrincipleDetailsSubBlockListOrNull;
}
export interface PrincipleDetailsSubBlock {
  content: RichTextBlockOrNull;
}
export interface PrinciplesBlock {
  principles_tabs?: PrinciplesSubBlockListOrNull;
}
export interface PrinciplesSubBlock {
  header: CharBlockOrNull;
  sub_header: CharBlockOrNull;
  link?: SupernalLinkSubBlockOrNull;
}
export interface StaggeredImageTextBlock {
  staggered_tiles?: StaggeredImageTextSubBlockListOrNull;
}
export interface StaggeredImageTextSubBlock {
  image?: ImageChooserBlockOrNull;
  body: RichTextBlockOrNull;
  link?: SupernalLinkSubBlockOrNull;
}
export interface TabbedBlock {
  color_options?: ColorOptionsSubBlockOrNull;
  default_image?: ImageChooserBlockOrNull;
  tabs?: TabbedSubBlockListOrNull;
}
export interface TabbedSubBlock {
  image?: ImageChooserBlockOrNull;
  content: RichTextBlockOrNull;
  include_more_less_toggle?: BooleanBlockOrNull;
}
export interface TimelineBlock {
  header: CharBlockOrNull;
  timelines?: TimelineSubBlockListOrNull;
}
export interface TimelineSubBlock {
  date: DateBlockOrNull;
  headline: CharBlockOrNull;
}
export interface TeamMembersBlock {
  header: RichTextBlock;
  page: PageChooserBlock;
  team_members: {
    id: number;
    title: string;
    headshot: ImageChooserBlockOrNull;
    job_title: string;
    bio: RichTextBlock;
    linkedin_profile: string;
  }[];
}
export interface ValuePropsBlock {
  header: RichTextBlockOrNull;
  value_props?: CmsValuePropListOrNull;
}
export interface Cms4 {
  id: number;
  image: ImageChooserBlockOrNull;
  video: VideoChooserBlockOrNull;
  title: CharBlock;
  copy: RichTextBlock;
}
export interface VehicleLandingBlock {
  media: MediaChooserBlockOrNull;
}
export interface ServerCmsForms {
  name: "server.cms.forms.ContactUsForm";
  errors: {
    category?: string[];
    first_name?: string[];
    last_name?: string[];
    email?: string[];
    phone?: string[];
    company_name?: string[];
    city?: string[];
    message?: string[];
    personal_data_consent?: string[];
    signup_newsletter?: string[];
  } | null;
  fields: {
    category: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    first_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    last_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    email: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsEmailInput;
    } & {};
    phone: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    company_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    city: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    message: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextarea;
    } & {};
    personal_data_consent: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsCheckboxInput;
    } & {};
    signup_newsletter: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsCheckboxInput;
    } & {};
  };
  prefix: string;
  iterator: (
    | "category"
    | "first_name"
    | "last_name"
    | "email"
    | "phone"
    | "company_name"
    | "city"
    | "message"
    | "personal_data_consent"
    | "signup_newsletter"
  )[];
  hidden_fields?: (
    | "category"
    | "first_name"
    | "last_name"
    | "email"
    | "phone"
    | "company_name"
    | "city"
    | "message"
    | "personal_data_consent"
    | "signup_newsletter"
  )[];
}
export interface ReactivatedSerializationFieldType {
  name: string;
  label: string;
  help_text: string | null;
}
export interface DjangoFormsWidgetsSelect {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  optgroups: [null, [ReactivatedSerializationWidgetsOptgroupMember], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedSerializationWidgetsBaseWidgetAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedSerializationWidgetsOptgroupMember {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsMaxLengthAttrs;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedSerializationWidgetsMaxLengthAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsEmailInput {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface DjangoFormsWidgetsTextarea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsTextareaAttrs;
  tag: "django.forms.widgets.Textarea";
}
export interface ReactivatedSerializationWidgetsTextareaAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface DjangoFormsWidgetsCheckboxInput {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedSerializationWidgetsCheckAttrs;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedSerializationWidgetsCheckAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface ServerCmsModelsPagesContactUsPageContactUsLandingPageTemplate {
  is_preview: boolean;
  page: ContactUsPage_104224242B;
}
export interface ContactUsPage_104224242B {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsContactUsPage;
  confirmation_message: RichTextField;
}
export interface ServerCmsModelsPagesHomePageHomePageTemplate {
  is_preview: boolean;
  page: HomePageD3Ba7Aa58E;
}
export interface HomePageD3Ba7Aa58E {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsHomePage;
}
export interface CmsHomePage {
  _type: "StreamField";
  _variant: "cms.HomePage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ServerCmsModelsPagesNewsCoverageLandingPageNewsCoverageLandingPageTemplate {
  is_preview: boolean;
  page: NewsCoverageLandingPageCf20B2545D;
}
export interface NewsCoverageLandingPageCf20B2545D {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsNewsCoverageLandingPage;
}
export interface CmsNewsCoverageLandingPage {
  _type: "StreamField";
  _variant: "cms.NewsCoverageLandingPage.body";
  value: NewsroomToolbox;
  [k: string]: unknown;
}
export interface MediaInquiryBlock {
  body?: RichTextBlockOrNull;
  media_kit?: DocumentChooserBlockOrNull;
  media_kit_cta_text?: CharBlockOrNull;
  contact_group?: CmsNewsContactInfoOrNull;
}
export interface DocumentChooserBlock {
  title: string;
  url: string;
  mimetype: string;
}
export interface NewsArticleGridBlock {
  header: CharBlockOrNull;
  page: PageChooserBlockOrNull;
  articles: (
    | {
        id: number;
        article_title: string;
        article_date: string;
        article_type?: string;
        article_tags?: string[] | null;
        article_url: string;
        image: ImageChooserBlockOrNull;
      }
    | {
        id: number;
        article_title: string;
        article_date: string;
        article_type?: string;
        article_tags?: string[] | null;
        article_url: string;
        image: ImageChooserBlockOrNull;
        event_daterange?: {
          lower?: string | null;
          upper?: string | null;
          [k: string]: unknown;
        };
        event_location?: string | null;
        event_booth?: string | null;
        event_url_text?: string | null;
        event_url?: string | null;
        event_logo?: ImageChooserBlockOrNull;
      }
  )[];
  next_url: string | null;
}
export interface ServerCmsModelsPagesTeamMembersLandingPageTeamMembersLandingPageTemplate {
  is_preview: boolean;
  page: TeamMembersLandingPage_8968A6A030;
}
export interface TeamMembersLandingPage_8968A6A030 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  team_members: ServerCmsModelsPagesTeamMemberPageTeamMemberTile[];
}
export interface ServerCmsModelsPagesTeamMemberPageTeamMemberTile {
  id: number;
  title: string;
  headshot: ThelabuiSerializationImagesImageBlockValue4 | null;
  job_title: string;
  bio: RichTextField;
  linkedin_profile: string;
}
export interface ThelabuiSerializationImagesImageBlockValue4 {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface ServerCmsModelsPagesUtilityPageUtilityPageTemplate {
  is_preview: boolean;
  page: UtilityPageEf4A701843;
}
export interface UtilityPageEf4A701843 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsUtilityPage;
  theme: string | null;
}
export interface CmsUtilityPage {
  _type: "StreamField";
  _variant: "cms.UtilityPage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ServerCmsContextProcessorsCoreAssetProcessor {
  core_assets: ServerCmsContextProcessorsCoreAssets;
}
export interface ServerCmsContextProcessorsCoreAssets {
  favicon: string;
  tracking: TrackingSettingsD8945Bf76F | null;
}
export interface TrackingSettingsD8945Bf76F {
  gtm_container_id: string | null;
}
export interface ServerCmsContextProcessorsSettingsProcessor {
  SENTRY_DSN: string | null;
  CI_COMMIT_REF_SLUG: string;
  CI_COMMIT_SHA: string;
  ENVIRONMENT: string;
}
export interface ServerCmsContextProcessorsNavigationProcessor {
  header_nav: HeaderNavigationSettings_41Bc9Da531 | null;
  footer_nav: FooterNavigationSettings_2441Cdc5E1 | null;
}
export interface HeaderNavigationSettings_41Bc9Da531 {
  body: CmsHeaderNavigationSettings;
}
export interface CmsHeaderNavigationSettings {
  _type: "StreamField";
  _variant: "cms.HeaderNavigationSettings.body";
  value: HeaderNavigationBodyBlock;
  [k: string]: unknown;
}
export interface MenuItemBlock {
  link?: SimpleLinkBlockOrNull;
  image: ImageChooserBlockOrNull;
}
export interface SimpleLinkBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  url: null | string;
}
export interface LegalBlock {
  links?: SupernalLinkSubBlockListOrNull;
  copyright: CharBlockOrNull;
}
export interface FooterNavigationSettings_2441Cdc5E1 {
  body: CmsFooterNavigationSettings;
}
export interface CmsFooterNavigationSettings {
  _type: "StreamField";
  _variant: "cms.FooterNavigationSettings.body";
  value: FooterNavigationBodyBlock;
  [k: string]: unknown;
}
export interface ServerCmsContextProcessorsSocialMediaShareProcessor {
  social_media_share: SocialMediaSettings_81410427Ab | null;
}
export interface SocialMediaSettings_81410427Ab {
  share_widget: CmsSocialMediaSettings;
}
export interface CmsSocialMediaSettings {
  _type: "StreamField";
  _variant: "cms.SocialMediaSettings.share_widget";
  value: SocialMediaShareBlock;
  [k: string]: unknown;
}
export interface SocialMediaShareSite {
  site: null | ("facebook" | "twitter" | "linkedin" | "envelope" | "link");
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

export type {Options} from "reactivated/dist/conf";
export type {Renderer} from "reactivated/dist/render.mjs";


export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as BasePageTemplateImplementation} from "@client/templates/BasePageTemplate"
export type BasePageTemplateCheck = Checker<_Types["BasePageTemplateProps"], typeof BasePageTemplateImplementation>;

export namespace templates {
    export type BasePageTemplate = _Types["BasePageTemplateProps"];
}


        



import {Template as BaseFormPageTemplateImplementation} from "@client/templates/BaseFormPageTemplate"
export type BaseFormPageTemplateCheck = Checker<_Types["BaseFormPageTemplateProps"], typeof BaseFormPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageTemplate = _Types["BaseFormPageTemplateProps"];
}


        



import {Template as BaseFormPageLandingPageTemplateImplementation} from "@client/templates/BaseFormPageLandingPageTemplate"
export type BaseFormPageLandingPageTemplateCheck = Checker<_Types["BaseFormPageLandingPageTemplateProps"], typeof BaseFormPageLandingPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageLandingPageTemplate = _Types["BaseFormPageLandingPageTemplateProps"];
}


        



import {Template as ExamplePageTemplateImplementation} from "@client/templates/ExamplePageTemplate"
export type ExamplePageTemplateCheck = Checker<_Types["ExamplePageTemplateProps"], typeof ExamplePageTemplateImplementation>;

export namespace templates {
    export type ExamplePageTemplate = _Types["ExamplePageTemplateProps"];
}


        



import {Template as LabUIToolboxSnippetPreviewImplementation} from "@client/templates/LabUIToolboxSnippetPreview"
export type LabUIToolboxSnippetPreviewCheck = Checker<_Types["LabUIToolboxSnippetPreviewProps"], typeof LabUIToolboxSnippetPreviewImplementation>;

export namespace templates {
    export type LabUIToolboxSnippetPreview = _Types["LabUIToolboxSnippetPreviewProps"];
}


        



import {Template as NewsArticlePageTemplateImplementation} from "@client/templates/NewsArticlePageTemplate"
export type NewsArticlePageTemplateCheck = Checker<_Types["NewsArticlePageTemplateProps"], typeof NewsArticlePageTemplateImplementation>;

export namespace templates {
    export type NewsArticlePageTemplate = _Types["NewsArticlePageTemplateProps"];
}


        



import {Template as TeamMemberPageTemplateImplementation} from "@client/templates/TeamMemberPageTemplate"
export type TeamMemberPageTemplateCheck = Checker<_Types["TeamMemberPageTemplateProps"], typeof TeamMemberPageTemplateImplementation>;

export namespace templates {
    export type TeamMemberPageTemplate = _Types["TeamMemberPageTemplateProps"];
}


        



import {Template as ContactUsPageTemplateImplementation} from "@client/templates/ContactUsPageTemplate"
export type ContactUsPageTemplateCheck = Checker<_Types["ContactUsPageTemplateProps"], typeof ContactUsPageTemplateImplementation>;

export namespace templates {
    export type ContactUsPageTemplate = _Types["ContactUsPageTemplateProps"];
}


        



import {Template as ContactUsLandingPageTemplateImplementation} from "@client/templates/ContactUsLandingPageTemplate"
export type ContactUsLandingPageTemplateCheck = Checker<_Types["ContactUsLandingPageTemplateProps"], typeof ContactUsLandingPageTemplateImplementation>;

export namespace templates {
    export type ContactUsLandingPageTemplate = _Types["ContactUsLandingPageTemplateProps"];
}


        



import {Template as HomePageTemplateImplementation} from "@client/templates/HomePageTemplate"
export type HomePageTemplateCheck = Checker<_Types["HomePageTemplateProps"], typeof HomePageTemplateImplementation>;

export namespace templates {
    export type HomePageTemplate = _Types["HomePageTemplateProps"];
}


        



import {Template as NewsCoverageLandingPageTemplateImplementation} from "@client/templates/NewsCoverageLandingPageTemplate"
export type NewsCoverageLandingPageTemplateCheck = Checker<_Types["NewsCoverageLandingPageTemplateProps"], typeof NewsCoverageLandingPageTemplateImplementation>;

export namespace templates {
    export type NewsCoverageLandingPageTemplate = _Types["NewsCoverageLandingPageTemplateProps"];
}


        



import {Template as TeamMembersLandingPageTemplateImplementation} from "@client/templates/TeamMembersLandingPageTemplate"
export type TeamMembersLandingPageTemplateCheck = Checker<_Types["TeamMembersLandingPageTemplateProps"], typeof TeamMembersLandingPageTemplateImplementation>;

export namespace templates {
    export type TeamMembersLandingPageTemplate = _Types["TeamMembersLandingPageTemplateProps"];
}


        



import {Template as UtilityPageTemplateImplementation} from "@client/templates/UtilityPageTemplate"
export type UtilityPageTemplateCheck = Checker<_Types["UtilityPageTemplateProps"], typeof UtilityPageTemplateImplementation>;

export namespace templates {
    export type UtilityPageTemplate = _Types["UtilityPageTemplateProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

